import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserDetailsState } from '../reducers/user-details.reducer';

export const selectUserDetailsState = createFeatureSelector<UserDetailsState>('userDetails');

export const selectLoading = createSelector(selectUserDetailsState, state => state.loading > 0);

export const selectPending = createSelector(selectUserDetailsState, state => state.pending > 0);

export const selectUser = createSelector(selectUserDetailsState, state => state.user);
